import { StyleSheet } from 'react-native';
import AppConstants from '../AppConstants.js';

const stylesForContentitems = StyleSheet.create({

  contentItemFrame: {
    borderColor: '#ccc',
    borderWidth: 1,
    justifyContent: 'center',
    backgroundColor: 'white',
    minHeight: 150,
    padding: 10,
    margin: 20,
    borderRadius: 10,
  },

  contentItemCover: {
    backgroundColor: AppConstants.seekingColor,
    justifyContent: 'center',
    flexDirection: 'row',
    margin: 20,
    borderRadius: 10,
    padding: 10
  },

  captionCover: {
    backgroundColor: AppConstants.arrivedColor,
    justifyContent: 'center',
    flexDirection: 'row',
    margin: 20,
    borderRadius: 10,
  },

  preludeCover: {
    backgroundColor: AppConstants.preludeCoverColor,
    justifyContent: 'center',
    flexDirection: 'row',
    margin: 20,
    borderRadius: 10,
  },

  overtureCover: {
    backgroundColor: AppConstants.overtureCoverColor,
    justifyContent: 'center',
    flexDirection: 'row',
    margin: 20,
    borderRadius: 10,
  },

  finaleCover: {
    backgroundColor: AppConstants.seekingColor,
    justifyContent: 'center',
    flexDirection: 'row',
    margin: 20,
    borderRadius: 10,
  },

  contentItemCoverText: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 26,
  },
  contentItemCoverTextLarge: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 32,
  },

  contentItemText: {
    fontSize: 22,
    textAlign: 'center',
  },
  contentItemTextLarge: {
    fontSize: 28,
    fontWeight: 'bold',
    textAlign: 'center',
  },

  preludeItemText: {
    fontSize: 18,
    textAlign: 'center',
    color: '#333'
  },
  preludeItemTextLarge: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#333'
  },

  finaleItemText: {
    fontSize: 22,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#eee',
  },

  finaleItemTextLarge: {
    fontSize: 28,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#eee',
  },
})

export default stylesForContentitems;
